/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

import APIManager from "../../../ApiManager/ApiManager";
import {
  FETCH_GLOBAL_CATEGORIES_REQUEST,
  FETCH_GLOBAL_CATEGORIES_SUCCESS,
  FETCH_GLOBAL_CATEGORIES_FAILURE,
  COMMON_ERROR,
} from "./GlobalAdminCategoriesTypes";

export const fetchGlobalCategoriesRequest = () => ({
  type: FETCH_GLOBAL_CATEGORIES_REQUEST,
});

export const fetchGlobalCategoriesSuccess = (categories) => ({
  type: FETCH_GLOBAL_CATEGORIES_SUCCESS,
  payload: categories,
});

export const fetchGlobalCategoriesFailure = (error) => ({
  type: FETCH_GLOBAL_CATEGORIES_FAILURE,
  payload: error,
});

export const fetchGlobalAdminCategoriesDetails = () => {
  return async function (dispatch) {
    dispatch(fetchGlobalCategoriesRequest());
    try {
      const data = await APIManager.getCategories();
      dispatch(fetchGlobalCategoriesSuccess(data));
    } catch (err) {
      dispatch(fetchGlobalCategoriesFailure(err.message));
    }
  };
};

export const commonError = (error, errorType) => {
  return {
    type: COMMON_ERROR,
    payload: {
      message: error.message,
      errorType: errorType,
    },
  };
};
